import { render } from "./VerifyPage.vue?vue&type=template&id=35b518e8&ts=true"
import script from "./VerifyPage.vue?vue&type=script&lang=ts"
export * from "./VerifyPage.vue?vue&type=script&lang=ts"

import "./VerifyPage.vue?vue&type=style&index=0&id=35b518e8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__